/* Native details provide keyboard support and work without JavaScript. */
if (!customElements.get('gs-footer-menus')) {
  customElements.define('gs-footer-menus', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(min-width: 768px)');
      this.syncMenus = () => {
        this.querySelectorAll('.gs-footer__menu').forEach(menu => {
          menu.open = this.media.matches;
        });
      };
      this.syncMenus();
      this.media.addEventListener('change', this.syncMenus);
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.syncMenus);
    }
  });
}
